import { AbstractPmsApiService } from './abstract.service';
import { Reservation } from '../models';

/**
 * @class OnlineReservationPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<Reservation>}
 */
export class OnlineReservationPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/online-reservation';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {Reservation}
     * @protected
     */
    newModel(attributes, ...params) {

        return new Reservation(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<Reservation>>}
     */
    get(params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        const ignoreLB = params.hasOwnProperty('searchValue');

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
                ignoreLoadingBar: ignoreLB
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/online-reservation.service.js